console.debug("Module loaded: AdHoc");

window.WidgetFactory = new class {
    makeDatePickerOptions(options) {
        return Object.assign({}, {
            onRenderCell(date, cellType) {
                // NOTE: disabledDays and disabledDays are custom data attributes

                let disabledDaysOfWeek = this.disabledDaysOfWeek || [];
                let disabledDays = this.disabledDays || [];

                if (cellType === 'day') {
                    let isDisabled = false;

                    let dayOfWeek = date.getDay();

                    isDisabled = disabledDaysOfWeek.indexOf(dayOfWeek) != -1;

                    let day = date.toYYMMDD();

                    isDisabled = isDisabled || disabledDays.includes(day);

                    return {
                        disabled: isDisabled
                    };
                }
            }
        }, options);
    }
};

export function getBackendMode() {
    try {
        return document.querySelector('meta[name="app-env"]').content;
    } catch (e) {
        console.warn('meta[name="app-env"] element not found');
    }

    return 'development';
}

export function getBrainTreeToken() {
    try {
        return document.querySelector('meta[name="braintree-token"]').content;
    } catch (e) {
        console.error('meta[name="braintree-token" content="BRAIN_TREE_TOKEN"] element not found');
    }
}

export function getGoogleMerchantId() {
    try {
        return document.querySelector('meta[name="google-merchant-id"]').content;
    } catch (e) {
        console.error('meta[name="google-merchant-id"] element not found');
    }
}
